import { paths } from 'core/routing/paths';
import { safeHttpUrl } from 'shared/utilities/format';

const ACTION_ROUTES = {
  open_result: (action = {}) => {
    const id = action.attempt_id || action.attemptId;
    return id ? paths.result(id) : paths.results;
  },
  open_consultation: (action = {}) => {
    const id = action.consultation_id || action.consultationId;
    return id ? paths.consultation(id) : paths.consultations;
  },
  open_support_ticket: (action = {}) => {
    const id = action.ticket_id || action.ticketId;
    return id ? paths.supportTicket(id) : paths.support;
  },
  open_legal_document: (action = {}) => {
    const type = String(action.type || action.screen || '').toLowerCase();
    if (type === 'privacy') {
      return paths.privacy;
    }
    return paths.terms;
  },
};

export function resolveNotificationPath(notification) {
  if (!notification) {
    return null;
  }
  const actionType = notification.action_type || notification.actionType;
  const action = notification.action && typeof notification.action === 'object' ? notification.action : {};
  const resolver = ACTION_ROUTES[actionType];
  if (resolver) {
    return resolver(action);
  }
  if (typeof action.path === 'string' && action.path.startsWith('/') && !action.path.startsWith('//')) {
    const allowed = resolver || ACTION_ROUTES[action.screen];
    if (allowed) {
      return allowed(action);
    }
  }
  return null;
}

export function resolveSafeExternalUrl(value) {
  return safeHttpUrl(value);
}
